import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import SignIn from "layouts/SignIn/SignIn.jsx";
import SignUp from "layouts/SignUp/SignUp.jsx";
import StartPage from "layouts/StartPage/StartPage.jsx";

const indexRoutes = [
  { path: "/start", component: StartPage },
  { path: "/signin", component: SignIn },
  { path: "/signup", component: SignUp },
  { path: "/", component: Dashboard }
];

export default indexRoutes;
